import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteContractTemplate,
  useGetContractTemplate,
} from 'services/templates/contract-template';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const ContractTemplate = () => {
  const id = useParamId('/templates');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const removeContractTemplate = useDeleteContractTemplate(id);

  const contractTemplate = useGetContractTemplate(id);

  const onRemoveContractTemplate = async (actions: PopupActions) => {
    await removeContractTemplate.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates'),
    });
  };

  return (
    <Form.Contract
      tittle={t('contract-template.contract.title')}
      backPath='templates'
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(`/templates/contract/edit/${id}/form`, {
                replace: true,
              })
            }>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveContractTemplate}
            removeLoading={removeContractTemplate.isPending}
            name={contractTemplate.data?.title}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.contract.initialStatus,
        displayMode: true,
      }}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: contractTemplate.data
          ? middleware.template.contractTemplate.queryToForm(
              contractTemplate.data
            )
          : contractTemplateUtil.contract.initialValues,
      }}
      onSubmit={() => {}}
      status={{ displayMode: true }}
    />
  );
};

export default ContractTemplate;
